<template>
  <div
    v-if="isLoading"
    :class="loadingClass"
    :style="loadingStyle"
  >
    <div class="loading">
      <span class="loader" />
    </div>
  </div>

  <div v-else-if="isEmpty">
    <p style="margin-bottom:0px;padding-top:10px;padding-bottom:10px;margin-left:5px;">
      {{ $t('NotFoundOrder') }}
    </p>
  </div>

  <div v-else>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    requestId: {
      type: String,
      default: '',
    },
    // isLoading: {
    //   type: Boolean,
    //   default: false,
    // },
    responseData: {
      type: [Array, Object, String, Boolean, null],
      default: null,
    },
    loadingClass: {
      type: String,
      default: 'classOfRequest',
    },
    loadingStyle: {
      type: String,
      default: '',
    },
  },
  computed: {
    isLoading() {
      return this.$store.getters.isRequestLoading(this.requestId);
    },
    isEmpty() {
      if (this.responseData === null || this.responseData === undefined) {
        return false;
      }
      return (
        this.responseData === ''
    || (Array.isArray(this.responseData) && this.responseData.length === 0)
    || (typeof this.responseData === 'object' && Object.keys(this.responseData).length === 0)
      );
    },
  },
};
</script>
